import React from "react"
import { HStack, Text } from "@chakra-ui/react"
import FullScreenModalNav from "components/dialogs/FullScreenModalNav"

/** The editor's dark top bar: a title on the left, a name in the middle, actions on the right. */
export const EditorHeader = ({ children }: { children: React.ReactNode }) => (
  <FullScreenModalNav type="header">{children}</FullScreenModalNav>
)

type TitleProps = {
  /** There are unsaved changes: the title gets a *. */
  dirty?: boolean
  children: React.ReactNode
}

export const EditorTitle = ({ dirty = false, children }: TitleProps) => (
  <Text w={1 / 3} fontSize="initial" color="gray.100" noOfLines={1}>
    {children}
    {dirty ? "* " : ""}
  </Text>
)

/** The editor's name, centred. */
export const EditorName = ({ children }: { children: React.ReactNode }) => (
  <Text color="white" fontSize="large" fontWeight="semibold">{children}</Text>
)

export const EditorActions = ({ children }: { children: React.ReactNode }) => (
  <HStack spacing={4} w={1 / 3} justify="flex-end">
    {children}
  </HStack>
)
